import script from "./AdminLandingPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminLandingPage.vue?vue&type=script&setup=true&lang=ts"

import "./AdminLandingPage.vue?vue&type=style&index=0&id=a2cc67d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2cc67d0"]])

export default __exports__